import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getRentalCarDiscountCodesSuccess, getRentalCarDiscountCodesRequest } from '../../slices/user';

function* getRentalCarDiscountCodesWorker() {
  try {
    const { loaded, rentalCarDiscountCodes } = yield select((store) => store.user);

    if (loaded && !rentalCarDiscountCodes) {
      const url = 'users/agencyRentalCarDiscountCodes';
      const config = {
        method: 'GET',
        url,
      };
      const { data } = yield call(axios, config);
      yield put(getRentalCarDiscountCodesSuccess(data));
    }
  } catch (error) {
    yield put(getRentalCarDiscountCodesSuccess());
    console.error(error);
  }
}

function* getRentalCarDiscountCodesWatcher() {
  yield takeLatest(getRentalCarDiscountCodesRequest.toString(), getRentalCarDiscountCodesWorker);
}

export default getRentalCarDiscountCodesWatcher;
